import type { Point, ViewTransform } from "../types";

export type MediaQuarterTurn = ViewTransform["rotation"];

export interface MediaBounds {
  width: number;
  height: number;
}

export function normalizeMediaRotation(value: number | undefined): MediaQuarterTurn {
  const normalized = ((Math.round((value ?? 0) / 90) * 90) % 360 + 360) % 360;
  return normalized as MediaQuarterTurn;
}

export function nextMediaRotation(value: number | undefined): MediaQuarterTurn {
  return ((normalizeMediaRotation(value) + 90) % 360) as MediaQuarterTurn;
}

export function rotatedMediaBounds(bounds: MediaBounds, rotation: MediaQuarterTurn): MediaBounds {
  return rotation === 90 || rotation === 270
    ? { width: bounds.height, height: bounds.width }
    : bounds;
}

export function rotateMediaPoint(point: Point, bounds: MediaBounds, rotation: MediaQuarterTurn): Point {
  if (rotation === 90) return { x: bounds.height - point.y, y: point.x };
  if (rotation === 180) return { x: bounds.width - point.x, y: bounds.height - point.y };
  if (rotation === 270) return { x: point.y, y: bounds.width - point.x };
  return point;
}

export function unrotateMediaPoint(point: Point, bounds: MediaBounds, rotation: MediaQuarterTurn): Point {
  if (rotation === 90) return { x: point.y, y: bounds.height - point.x };
  if (rotation === 180) return { x: bounds.width - point.x, y: bounds.height - point.y };
  if (rotation === 270) return { x: bounds.width - point.y, y: point.x };
  return point;
}
